import React from "react";

export const getMetricConfig = (val1, val2, additionalValues = [], isPercentage = false) => {
  const v1 = !isNaN(Number(val1)) ? Number(val1) : 0;
  const v2 = !isNaN(Number(val2)) ? Number(val2) : 0;

  // Handles both array and object inputs for additionalValues
  const otherVals = Array.isArray(additionalValues)
    ? additionalValues.map((v) => Number(v)).filter((v) => !isNaN(v))
    : Object.values(additionalValues || {})
        .map((v) => Number(v))
        .filter((v) => !isNaN(v));

  const maxVal = Math.max(v1, v2, ...otherVals, 0);

  if (isPercentage) {
    return {
      divisor: 1,
      suffix: "%",
      formatVal: (val) => {
        if (!val || isNaN(Number(val))) return "0";
        const num = Number(val);
        return (
          <div className="flex items-center gap-1">
            <span>{num.toFixed(2)}</span>
            <span className="text-xs">%</span>
          </div>
        );
      },
    };
  }

  if (maxVal >= 10000000) {
    return {
      divisor: 10000000,
      suffix: " Cr",
      formatVal: (val) => {
        if (!val || isNaN(Number(val)) || Number(val) === 0) return "0";
        const crVal = Number(val) / 10000000;
        return (
          <div className="flex items-center gap-1">
            <span>{crVal.toFixed(2)}</span>
            <span className="text-xs"> Cr</span>
          </div>
        );
      },
    };
  }

  if (maxVal >= 100000) {
    return {
      divisor: 100000,
      suffix: " L",
      formatVal: (val) => {
        if (!val || isNaN(Number(val)) || Number(val) === 0) return "0";
        const lVal = Number(val) / 100000;
        return (
          <div className="flex items-center gap-1">
            <span>{lVal.toFixed(2)}</span>
            <span className="text-xs"> L</span>
          </div>
        );
      },
    };
  }

  if (maxVal >= 1000) {
    return {
      divisor: 1000,
      suffix: " K",
      formatVal: (val) => {
        if (!val || isNaN(Number(val)) || Number(val) === 0) return "0";
        const kVal = Number(val) / 1000;
        return (
          <div className="flex items-center gap-1">
            <span>{kVal.toFixed(2)}</span>
            <span className="text-xs"> K</span>
          </div>
        );
      },
    };
  }

  return {
    divisor: 1,
    suffix: "",
    formatVal: (val) => {
      if (!val || isNaN(Number(val)) || Number(val) === 0) return "0";
      const num = Number(val);
      const isFloat = num % 1 !== 0;
      const formatted = isFloat 
        ? num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
        : num.toLocaleString("en-IN");

      return (
        <div className="flex items-center gap-1">
          <span>{formatted}</span>
        </div>
      );
    },
  };
};
